import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const JSM_PRODUCT_KEY = 'jira-servicedesk.ondemand';

export const fetchHamsEntitlementDetails = async (cloudId: string) =>
	fetchJson(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group`);
